<template>
    <div class="booking-form">
        <Booking></Booking>
    </div>
</template>

<script>
import Booking from '@/views/booking/Booking.vue';

export default {
    components: { Booking },
    setup() {
        
    },
}
</script>
